
import { FC, useContext, useEffect, useState } from "react"

import useFetch from "src/hooks/useFetch";
import { AuthContext } from "src/context/authContext";
import { LoaderContext } from "src/context/loaderContext";
import { downloadExcelFile } from "src/helpers/downloadFile";
import { ToastContext } from "src/context/toastContext";

import { APIEndpoints } from "src/types/apiTypes";
import { DownloadReportsResponseTypeApi, StatsReportProps } from "./types";
import { ToastTypes } from "src/types";



const StatsReports: FC<StatsReportProps> = ({ getValues }): JSX.Element => {
  const [enabledButton, setEnabledButton] = useState<boolean>(false);

  const { userData } = useContext(AuthContext)
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { showToast } = useContext(ToastContext);





  const {
    data: downloadReportsData, error: downloadReportsError, mutate: downloadRequestForm,
    removeErrorAndData: clearRequestFileData
  } = useFetch<DownloadReportsResponseTypeApi>(APIEndpoints.MANUFACTURE_STATISTICS_REPORT_DOWNLOAD);

  useEffect(() => {
    if (downloadReportsData || downloadReportsError) {
      if (downloadReportsData) {
        const { response, report_name } = downloadReportsData;
        downloadExcelFile(response, `${report_name}.xlsx`);
        showToast(["Report downloaded successfully"], ToastTypes.SUCCESS)
      }
      hideLoader()
      setEnabledButton(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadReportsData, downloadReportsError]);

  const downloadReport = (reportName: string) => {
    if (getValues) {
      let params = {
        'start_date': getValues().start_date,
        'end_date': getValues().end_date,
        'report_name': reportName,
        ...(userData && userData.ref_type === "rep" ? { user_id: userData.id } : {})
      }
      if (downloadReportsData || downloadReportsError) clearRequestFileData();

      setLoader();
      setEnabledButton(true)
      downloadRequestForm({}, {}, params);
    }
  }




  return (
    <div className="row">
      {enabledButton ? (
        <div className="col">
          <p className="text-dark h5">
            <span className="spinner-border spinner-border-sm" style={{ width: 20, height: 20 }} aria-hidden="true"></span>{' '}
            <i>Fetching Report</i>
          </p>
        </div>
      ) : (
        <>
          <div className="col-12 col-sm-4 mb-2 mb-sm-0">
            <button
              className="btn btn-success w-100"
              onClick={() => downloadReport("prior_auths_report")}
            >
              Prior Auths Report
            </button>
          </div>

          <div className="col-12 col-sm-4 mb-2 mb-sm-0">
            <button
              className="btn btn-success w-100"
              onClick={() => downloadReport("full_report")}
            >
              Full Report
            </button>
          </div>

          <div className="col-12 col-sm-4 mb-2 mb-sm-0">
            <button
              className="btn btn-success w-100"
              onClick={() => downloadReport("call_report")}
            >
              Call Report
            </button>
          </div>
        </>
      )}
    </div>
  )
}

export default StatsReports;
